var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00004 0H20C21.6503 0 23 1.35009 23 3.00004V15.0002C23 16.6505 21.6503 18.0003 20 18.0003H14.0004L8 24V17.9999H4.00004C2.35009 17.9999 1 16.6502 1 15.0002V3.00004C1 1.35009 2.35009 0 4.00004 0ZM10.5926 12.0002H13V11.5797C13 10.8723 13.2494 10.358 14.3892 9.44287C15.4867 8.56092 16 7.64581 16 6.57512V6.36486C16 4.35754 14.3892 3.00004 12.0383 3.00004C9.57375 3.00004 8.00035 4.45315 8.00035 6.76633V7.2634H10.4839V6.78538C10.4839 5.8678 11.0526 5.31358 12.0196 5.31358C12.9294 5.31358 13.4984 5.79124 13.4984 6.53702V6.72823C13.4984 7.2253 13.2049 7.63487 12.3417 8.33408C10.987 9.43194 10.5929 10.2416 10.5929 11.446L10.5926 12.0002ZM10.5277 16H12.9996V13.5274H10.5277V16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon_support.2f7aa2f95b27b8c55fcab554d79c40fa.svg";
export { ForwardRef as ReactComponent };